const errors = {
  PASSWORD_NO_MATCH: "Password must match with the Confirm Password field!",
  PASSWORD_SHORT: "Password must be at least 8 characters long!",
  REQUIRED_FIELDS: "You must fill all the required fields!",
  MIN_ONE_OPTION: "Please select atleast one option!"
};

export default errors;
